<template>
  <v-hover v-slot="{ hover }">
    <div
      :elevation="hover ? 12 : 2"
      :class="{ 'on-hover': hover, 'hover-block': true }"
    >
      <span
        class="subheading font-weight-bold pa-0 ma-0"
        :class="{ 'on-hover': hover, 'hover-block': true }"
        hover="hover"
      >
        {{ item }}
      </span>
      <span>
        <HoverBtn :hover="hover" icon="edit" @handler="$emit('edit')" />
        <HoverBtn
          v-if="isDelete"
          :hover="hover"
          icon="delete"
          @handler="$emit('delete')"
        />
      </span>
    </div>
  </v-hover>
</template>
<script>
import HoverBtn from "./HoverBtn.vue";

export default {
  components: {
    HoverBtn,
  },
  props: {
    item: {
      type: String,
      Object,
    },
    isDelete: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
